var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vk-nav',{staticClass:"tm-nav"},[_c('vk-nav-item-header',{attrs:{"title":_vm.title}}),_vm._l((_vm.items),function(route,name){return _c('router-link',{key:route,attrs:{"tag":"li","to":route}},[_c('a',[_vm._v(_vm._s(name))])])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }